<template>
  <a-modal
    :title="title"
    :width="width"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭">
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item label="知识库类型" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input :value="formData.knowledgeTypeName" disabled="disabled"></a-input>
        </a-form-item>
        <a-form-item label="文件名" :labelCol="labelCol" :wrapperCol="wrapperCol" v-if="formData.annexId">
          <a-input v-model="formData.name"></a-input>
        </a-form-item>
        <a-upload-dragger
          :action="url.upload"
          :multiple="false"
          :headers="tokenHeader"
          :file-list="fileList"
          @change="handleChange"
          :disabled="fileList.length > 0"
        >
          <p class="ant-upload-drag-icon">
            <a-icon type="inbox"/>
          </p>
          <p class="ant-upload-text">
            单击或拖动文件到此区域以上传
          </p>
        </a-upload-dragger>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>

import {httpAction} from '@/api/manage'
import pick from 'lodash.pick'
import {validateDuplicateValue} from '@/utils/util'
import Vue from "vue";
import {ACCESS_TOKEN} from "@/store/mutation-types";

export default {
  name: "BusKnowledgeFileModal",
  components: {},
  data() {
    return {
      tokenHeader: {'X-Access-Token': Vue.ls.get(ACCESS_TOKEN)},
      form: this.$form.createForm(this),
      formData: {
        knowledgeType: '',
        knowledgeTypeName: '',
        url: '',
        name: '',
        size: '',
        downloadCount: '',
        viewCount: '',
        isShow: '',
        remark: '',
        annexId: '',
        fileType: '',
      },
      title: "操作",
      width: 800,
      visible: false,
      model: {},
      labelCol: {
        xs: {span: 24},
        sm: {span: 5},
      },
      wrapperCol: {
        xs: {span: 24},
        sm: {span: 16},
      },
      confirmLoading: false,
      fileList: [],
      url: {
        upload: process.env.VUE_APP_domianURL + "/file.base/file/upload",
        add: "/knowledge.file/busKnowledgeFile/add",
        edit: "/knowledge.file/busKnowledgeFile/edit",
      }
    }
  },
  created() {
  },
  methods: {
    add(knowledgeType, knowledgeTypeName) {
      console.log(knowledgeType, knowledgeTypeName)
      this.formData.annexId = ''
      this.fileList = []
      this.visible = true;
      this.$nextTick(() => {
        this.formData.knowledgeType = knowledgeType
        this.formData.knowledgeTypeName = knowledgeTypeName
      })
      // this.edit({});
    },
    edit(record) {
      this.form.resetFields();
      this.model = Object.assign({}, record);
      this.visible = true;
      this.$nextTick(() => {
        this.form.setFieldsValue(pick(this.model, 'knowledgeType', 'url', 'name', 'size', 'downloadCount', 'viewCount', 'isShow', 'remark', 'annexId', 'fileType'))
      })
    },
    close() {
      this.$emit('close');
      this.visible = false;
    },
    handleOk() {
      if(!this.formData.annexId) {
        this.$message.warning('请上传文件');
        return
      }
      this.confirmLoading = true
      httpAction(this.url.add, this.formData, 'post').then((res) => {
        if (res.success) {
          this.$message.success(res.message);
          this.$emit('ok');
        } else {
          this.$message.warning(res.message);
        }
      }).finally(() => {
        this.confirmLoading = false;
        this.close();
      })
    },
    handleCancel() {
      this.close()
    },
    popupCallback(row) {
      this.form.setFieldsValue(pick(row, 'knowledgeTypeName', 'knowledgeType', 'url', 'name', 'size', 'downloadCount', 'viewCount', 'isShow', 'remark', 'annexId', 'fileType'))
    },
    handleChange(info) {
      console.log('文件上传结果====》', info)
      if (info.file) {
        let response = info.file.response
        console.log('文件上传结果====》response', response)
        if (response && response.success) {
          let file = response.result
          this.formData.url = file.url
          this.formData.name = file.name
          this.formData.size = file.size
          this.formData.annexId = file.id
          this.formData.fileType = file.fileType
          this.formData.fileType = file.type
        }
      }
      this.fileList = info.fileList
      console.log('文件====》', info, this.fileList)
    }

  }
}
</script>